import { render, staticRenderFns } from "./Aspsps.vue?vue&type=template&id=1915da76&scoped=true&"
import script from "./Aspsps.vue?vue&type=script&lang=js&"
export * from "./Aspsps.vue?vue&type=script&lang=js&"
import style0 from "./Aspsps.vue?vue&type=style&index=0&id=1915da76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1915da76",
  null
  
)

export default component.exports